var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _rect2, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitCardOr1InstallmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7954 17.0858L36.628 1.53281L0.837891 11.1227L6.99439 34.0991L10.8655 33.0619",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39453 16.2097L38.006 6.67251",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86328 21.6855L10.583 19.8859M39.4747 12.1483L21.2899 17.0185",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.7504,
    y: 17.1977,
    width: 36.8113,
    height: 23.2023,
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 33.0224L13.9043 33.0224",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7305 33.0224L22.0098 33.0224",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.834 33.0224L30.1133 33.0224",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9375 33.0224L38.2168 33.0224",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7094,
    y: 23.2982,
    width: 6.77769,
    height: 4.43131,
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.291 36.7766L13.9055 36.7766",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3069 23.5787L15.4982 24.2741L15.0977 23.7677L16.39 22.7096H17.0627V27.9849H16.3069V23.5787Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCardOr1InstallmentIcon);
export default __webpack_public_path__ + "static/media/debit-card-or-1-installment_icon.2fbd9bd7f343fb40b7598e9459fd2fc4.svg";
export { ForwardRef as ReactComponent };